import { YoutubeAnalyticsTrendPayload } from '@anytag/graphql';
import { TableV2 } from '@anytag/shared-atoms';
import { YoutubeTrendPostDetailsModal } from '@anytag/shared-molecules';
import { TableData } from '@anytag/shared-types';
import { useAnalyticsTrendingYoutubePostsTable } from './hooks';

export type AnalyticsTrendingYoutubePostsListProps = TableData<YoutubeAnalyticsTrendPayload>;

export const AnalyticsTrendingYoutubePostsList = ({ loading, data = [] }: AnalyticsTrendingYoutubePostsListProps) => {
  const { columns } = useAnalyticsTrendingYoutubePostsTable();

  return (
    <>
      <TableV2 loading={loading} data={data} columns={columns} rowHeight="130px" noTopBorderRadius hasBorder />
      <YoutubeTrendPostDetailsModal posts={data.map(({ id }) => ({ id: String(id) }))} />
    </>
  );
};
